import * as React from 'react'
import styled from 'styled-components'
import Tag, { TagProps } from 'antd/lib/tag'

import { RequestTicketState } from '../../../typings/types'
import { getStateName } from '../../../helpers/state-helper'

export const tagColor = (state: RequestTicketState) => {
  switch (state) {
    case RequestTicketState.ACTIVE:
    case RequestTicketState.MODERATION_CLAIMED:
    case RequestTicketState.RESOLVED:
      return '#108ee9'
    case RequestTicketState.MODERATION_APPROVED:
      return '#6fc400'
    case RequestTicketState.CANCELLED:
      return '#ff5500'
    default:
      return 'rgba(0, 0, 0, 0.65)'
  }
}

type TagSize = 'big' | 'small'

const StyledTag = styled<TagProps & { textColor: string; size: TagSize }>(
  ({ textColor, ...rest }) => <Tag {...rest} />
)`
  &.ant-tag {
    color: ${({ textColor }) => textColor};
    border: 1px solid ${({ textColor }) => textColor};
    opacity: 0.8;

    &:hover {
      cursor: default;
      opacity: 0.8;
    }

    font-size: 0.8rem;
    padding: 0 0.5rem;

    ${props =>
      props.size === 'big' &&
      `
      position: absolute;
      z-index: 1;
      right: 1rem;
      top: 0.7rem;
      font-size: 0.9rem;
      line-height: 1.9rem;
      height: 2rem;
      padding: 0 1rem;
    `};
  }
`

const RequestStateTag = ({
  state,
  size = 'big',
}: {
  state: RequestTicketState
  size?: TagSize
}) => {
  return (
    <StyledTag data-testid="state-tag" textColor={tagColor(state)} size={size}>
      {getStateName(state)}
    </StyledTag>
  )
}

export default RequestStateTag



// WEBPACK FOOTER //
// ./src/components/RequestDetailsPage/RequestStateTag/RequestStateTag.tsx